module.exports = __webpack_public_path__ + "static/media/abbiamo10.f47df5f2.png";